import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";
import { GetTireBrand, saveTireBrand } from "./index";
import { partBrandApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getTireBrandSaga(action: GetTireBrand) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(partBrandApi.getDomain, action.payload.idBrandType);
		if (response.data.result) {
			yield put(saveTireBrand(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveTireBrand(null, true, resultError.messagesDataError));
		}
	}
}
